// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"35b280ec","580":"502f469e","599":"fbbd49e5","718":"4bc00cdc","724":"81beacbc"}[chunkId] + ".chunk.css";
};